import {defineStore} from 'pinia'
import authRequests from '@/utils/authRequests.ts'
import router from '@/router'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null as null | {
            UserId: string,
            IdOnlstreet: number,
            Name: string,
            Email: string;
            Phone: string
        },
        receiver: null as null | {
            ReceiverName: string,
            ReceiverPhone: string,
            Address: string,
            ProvinceId: number,
            ProvinceName: string,
            DistrictId: number,
            DistrictName: string,
            WardId: number,
            WardName: string
        },
        minigame: null as null | Array<{
            "MinigameId": string,
            "Code": string,
            "Name": string,
            "Description": string,
            "NumRemaining": number
        }>,
        isAuthenticated: false,
        initialized: false,
        email: '',
        phone: '',
        refreshInProgress: false
    }),
    actions: {
        // Khởi tạo: kiểm tra session, tự động refresh nếu cần
        async initialize() {
            // try {
            const res = await authRequests.getUserInfo()
            this.user = res.data
            this.minigame = res.data.Minigame
            this.receiver = res.data.ReceiverInfo
            this.isAuthenticated = true
            // } catch (err: any) {
            // if (err.response?.status === 401) {
            //     try {
            //         await this.refreshToken()
            //     } catch {
            //         this.isAuthenticated = false
            //         // await this.logout()
            //     }
            // } else {
            //     this.isAuthenticated = false
            // }
            // } finally {
            // this.initialized = true
            // }
        },

        // Refresh token khi access hết hạn
        async refreshToken() {
            if (this.refreshInProgress) {
                console.warn('Refresh token đang được thực hiện, bỏ qua yêu cầu mới')
                return Promise.reject(new Error('Refresh in progress'))
            }

            this.refreshInProgress = true

            try {
                const res = await authRequests.refreshToken()
                this.user = res.data
                this.minigame = res.data.Minigame
                this.receiver = res.data.ReceiverInfo
                this.isAuthenticated = true
                return res
            } catch (err: any) {
                this.isAuthenticated = false
                await this.logout()
                throw err
            } finally {
                this.refreshInProgress = false
            }
        },

        // Đăng xuất: xóa cookie tại backend
        async logout() {
            if (router.currentRoute.value.path == '/login') return

            try {
                await authRequests.logout()
            } catch (err) {
                console.error('Lỗi khi đăng xuất:', err)
            } finally {
                this.user = null
                this.minigame = null
                this.receiver = null
                this.isAuthenticated = false
                this.refreshInProgress = false
                await router.push('/login')
            }
        }
    }
})